export default "__VITE_ASSET__BDt$j0T3__"